export default function(store, action) {
  return {
    ...store,
    hint: {
      ...store.hint,
      anchorEl: action.anchorEl,
      date: action.date,
      extraBed: action.extraBed,
      open: true,
      prices: action.prices,
      restrictions: action.restrictions,
      roomSize: action.size,
    },
  }
}
